import type { DisponibilidadDto, EstadoStock } from '@/types/inventario';

interface Props {
  disponibilidad?: DisponibilidadDto;
  /** Cantidad solicitada en la cotización actual (para el modo "demanda excede stock"). */
  demanded?: number;
  className?: string;
}

const ESTADO_STYLES: Record<EstadoStock, { bg: string; text: string; label: string }> = {
  OK:        { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Stock OK' },
  LIMITADO:  { bg: 'bg-amber-100',   text: 'text-amber-700',   label: 'Stock limitado' },
  SIN_STOCK: { bg: 'bg-red-100',     text: 'text-red-700',     label: 'Sin stock' },
};

/**
 * Badge informativo de disponibilidad global de un ítem.
 *   - Sin datos: no renderiza nada (silencioso para ítems sin sync en inventario).
 *   - Con `demanded` y demanded > cantidadDisponible: muestra alerta de stock excedido (override del estado).
 */
export function StockAvailabilityBadge({ disponibilidad, demanded, className }: Props) {
  if (!disponibilidad) return null;

  const excedido = demanded != null && demanded > disponibilidad.cantidadDisponible;
  if (excedido) {
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700 ${className ?? ''}`}>
        Stock insuficiente
      </span>
    );
  }

  const style = ESTADO_STYLES[disponibilidad.estado];
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text} ${className ?? ''}`}>
      {style.label}
    </span>
  );
}
